import React from "react";
import ReserveView from "./reserve/ReserveView";
import useInitBuyOrReserve from "../../../hooks/buy/useInitBuyOrReserve";

// This is component is necessary because the V1 also has a container to switch between toyota / lexus,
// this means we cannot call useInitBuyOrReserve inside the view directly.
const ReserveContainer = (): JSX.Element => {
    useInitBuyOrReserve();
    return <ReserveView />;
};

export default ReserveContainer;
